// src/app/auth.guard.ts
import { Injectable } from '@angular/core';
import {
  CanActivate
} from '@angular/router';
import { KeycloakAuthorizationService } from '../../auth/keycloak.authorization.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private kc: KeycloakAuthorizationService
  ) {}

  canActivate(): boolean {
    if (this.kc.isAuthenticated()) {
      return true;
    }
    // optionally kick off a login redirect
    this.kc.login();
    return false;
  }
}